import {
  useGlobalComponentForAttribute,
  TableInheritedProps
} from '@rhino-project/core/hooks';
import { CellTime } from '../../table/cells/CellTime';

export const ModelCellTimeBase = (props: TableInheritedProps) => (
  <CellTime {...props} />
);

export const ModelCellTime = (props: TableInheritedProps) =>
  useGlobalComponentForAttribute('ModelCellTime', ModelCellTimeBase, props);
